import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Modal, PrimaryButton } from 'utils';

/** Kleines Bestaetigungs-Fenster mit Abbrechen und einer Hauptaktion. */
function ConfirmModal({ open, title, text, confirmLabel, onConfirm, onCancel }) {
  return (
    <Modal width="480px" noLogo showModal={open} handelCloseModal={onCancel}>
      <Body>
        <div className="title">{title}</div>
        <div className="text">{text}</div>
        <div className="actions">
          <PrimaryButton primary={true} type="button" onClick={onCancel}>
            Abbrechen
          </PrimaryButton>
          <PrimaryButton primary={false} type="button" onClick={onConfirm}>
            {confirmLabel}
          </PrimaryButton>
        </div>
      </Body>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmModal;

const Body = styled.div`
  padding: 8px 24px 0;
  font-family: Inter, sans-serif;

  .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    color: #181d27;
  }

  .text {
    margin-top: 8px;
    font-size: 14px;
    line-height: 21px;
    color: #414651;
  }

  .actions {
    display: flex;
    gap: 12px;
    margin-top: 24px;
  }

  .actions button {
    flex: 1 1 auto;
    white-space: nowrap;
  }
`;
